<script>
    import { createEventDispatcher, onMount } from "svelte";
    import Modal from "$lib/UI/Dialog/Modal.svelte";
    import Button from "$lib/UI/Button.svelte";
    import { l } from "$lib/Utils/l10n.svelte";

    export let title;
    export let link;
    
    const dispatch = createEventDispatcher();

    function doClose() {
        dispatch("close");
    }

    function doOpen() {
        window.open(link);
    }

</script>

<Modal width="wide" title={l("Informatie")}>
    <div class="scroll-container">
        <iframe id="popup-frame" class="frame" src={link} title="{title}}" />
    </div>

    <div slot="footer" class="buttons">
        <div class="link">
            <a href={link} target="_blank">{title}</a>
        </div>
        <Button
            on:click={doClose}
            icon="circle-xmark"
            style="highlight"
            text={l("Sluiten")}
            tooltip={l("Sluiten")}
        />
    </div>
</Modal>

<style>
    .buttons {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding: 1rem;
    }

    .link{
        transform : translateY(20%);
    }

    .scroll-container {
        height: calc(100vh - var(--branding-height) - 200px);
        overflow-y: auto;
    }

    .frame {
        height: 100%;
        width: 100%;
        border: none;
    }

</style>
